import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/common/Layout/Layout'
import SPAHome from './pages/SPAHome'
import ProjectDetail from './pages/ProjectDetail'
import NotFound from './pages/NotFound'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<SPAHome />} />
        <Route path="project/:id" element={<ProjectDetail />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default App
